<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e996334" style="color: #82a339"><b>TAPENADE</b></p>
<p class="ext" id="d7e996834"><b><i>This Provençal olive spread can be enjoyed on crisp bread or crackers or as a condiment for fish or chicken.</i></b></p>
<p class="h4" id="d7e997834" style="color: #496210"><b>Prep: 20 minutes</b></p>
<p class="ul" id="d7e998334">2 garlic cloves, peeled</p>
<p class="ul" id="d7e998634">1½ cups Gaeta or Kalamata olives, pitted</p>
<p class="ul" id="d7e999734">½ cup pimiento-stuffed olives</p>
<p class="ul" id="d7e1000734">1 tablespoon olive oil</p>
<p class="ul" id="d7e1001034">1 teaspoon fennel seeds</p>
<p class="ul" id="d7e1001334">1 teaspoon freshly grated orange peel</p>
<p class="pub" id="d7e1001834" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 1-quart saucepan, heat <i>2 cups water </i>to boiling over high heat. Add garlic and cook 3 minutes to blanch; drain.</p>
<p class="pub" id="d7e1003634"><span style="color: #c15b49"><b>2.</b></span> In food processor with knife blade attached, combine olives, oil, fennel seeds, orange peel, and garlic; process until chopped. Transfer to bowl; cover and refrigerate up 3 days. Makes about 1¼ cups.</p>
<p class="ntx" id="d7e1006434">Each tablespoon: About 41 calories, 0g protein, 2g carbohydrate, 4g total fat (0g saturated), 0mg cholesterol, 264mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c17_r1.vue?312a0084